<script>
  // This component toggles the view (table/globe)
  import { VIEW } from '../stores.js';
  import tooltip from '../scripts/tooltip.js';

  // Subscribe to the view store to change the variable
  let isMap;
  VIEW.subscribe(value => { isMap = value; });

  // Clickling the toggle inverts the previous value
  function toggle () { VIEW.update((p) => !p); }

</script>

<div class="page-switch">
  <div
    class="switch"
    on:click={toggle}
    use:tooltip={{ content: `Klicken Sie um zur ${isMap ? 'Tabellen-' : 'Karten-'}Ansicht zu wechseln.`, followCursor: false }}
    aria-label={`Klicken Sie um zur ${isMap ? 'Tabellen-' : 'Karten-'}Ansicht zu wechseln.`}
    role="switch"
    aria-checked={String(isMap)}>
    <div
      class={`first ${ isMap ? 'isActive' : 'clickable' }`}>
      <i class="icon-globe" />
    </div>
    <div
      class={`last ${ !isMap ? 'isActive' : 'clickable' }`}>
      <i class="icon-table" />
    </div>
  </div>
</div>
